<template>
  <div>
    <chart ref="chart" :options="chartOptions" />
    <hr />
    <history-chart :data="historyData" />
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue'
import HistoryChart from './HistoryChart'

export default {
  components: {
    Chart,
    HistoryChart,
  },
  props: {
    slicedValue: {
      type: Number,
    },
    measurers: {
      type: Array,
    },
    selectedTotal: {
      type: Boolean,
    },
    summary: {
      type: Object,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'pie',
          backgroundColor: 'transparent',
          height: 275,
        },
        title: {
          text: null,
        },
        accessibility: {
          point: {
            valueSuffix: '%',
          },
        },
        tooltip: {
          pointFormat: `<span>Hodnota: </span><b>{point.y:.1f} ${this.getUnit()} </b> <span>({point.percentage:.1f}%)</span><br/>`,
        },
        series: [
          {
            name: '',
            colorByPoint: true,
            data: [],
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadPDF'],
            },
          },
          filename: 'podruzne-meradla_report',
        },
      },
      historyData: [],
    }
  },
  watch: {
    measurers() {
      this.filterItems()
    },
    slicedValue() {
      this.filterItems()
    },
  },
  mounted() {
    this.filterItems()
  },
  methods: {
    getUnit() {
      let type = this.$store.getters['energetic/getCurrentType']
      if (type === 'power') {
        return 'kWh'
      }
      if (type === 'gas') {
        return 'm3'
      }
      return ''
    },
    filterItems() {
      let sliced = {}
      if (this.slicedValue > 0) {
        sliced = {
          name: 'Nemeraná spotreba',
          y: this.slicedValue,
          color: '#e74c3c',
          selected: true,
          sliced: true,
          dataLabels: {
            color: '#e74c3c',
          },
        }
      }
      let chartData = this.measurers.slice(0, 10)
      this.historyData = chartData
      let dataLength = chartData.length
      let chartDataConsumption = chartData.reduce(
        (accumulator, row) => row.consumption + accumulator,
        0,
      )
      chartData = chartData.map((item) => {
        return {
          name: item.device.name,
          y: item.consumption,
        }
      })

      let remains = this.measurers.slice(10)
      let remainsLength = remains.length
      remains = remains.reduce(
        (accumulator, row) => row.consumption + accumulator,
        0,
      )

      if (this.selectedTotal) {
        remains = this.summary.totalConsumption - chartDataConsumption
        remainsLength = this.summary.totalMeasurers - dataLength
      }

      let chartRemains = {}
      if (remainsLength) {
        chartRemains = {
          name: `OSTATNÉ (${remainsLength})`,
          y: remains,
          selected: true,
        }
      }

      this.chartOptions.series[0].data = [sliced, ...chartData, chartRemains]
    },
  },
}
</script>
